import { LoadingOverlay } from "components/layout/LoadingOverlay";
import { NothingFound } from "./NothingFound";

const TableViewContainer = ({ children }: React.ComponentProps<"div">) => {
    return <div className="flex flex-col gap-4">{children}</div>;
};

export function TableView<
    TData extends { total: number },
    TError extends { readonly message: string },
>({
    children,
    data,
    emptyCollection,
    error,
    footer,
    header,
    isInitialLoading,
    isFiltering,
    nothingFound,
    onClearFilters,
}: {
    children: (data: TData) => React.ReactNode;
    data?: TData | null;
    emptyCollection?: React.ReactNode;
    error?: TError | null;
    footer?: React.ReactNode;
    header?: React.ReactNode;
    isInitialLoading?: boolean;
    isFiltering?: boolean;
    nothingFound?: boolean;
    onClearFilters?: () => void;
}) {
    if (isInitialLoading) {
        return (
            <TableViewContainer>
                <LoadingOverlay />
            </TableViewContainer>
        );
    }

    if (error) {
        return (
            <TableViewContainer>
                <div>Error: {error.message}</div>
            </TableViewContainer>
        );
    }

    if (data && data.total === 0 && isFiltering === false) {
        return (
            <TableViewContainer>
                {emptyCollection ? (
                    emptyCollection
                ) : (
                    <div>There is nothing here yet. Try adding something?</div>
                )}
            </TableViewContainer>
        );
    }

    return (
        <TableViewContainer>
            {header}
            {nothingFound && <NothingFound onClearFilters={onClearFilters} />}
            {data && children(data)}
            {footer}
        </TableViewContainer>
    );
}
